import { gql } from "@apollo/client";

export const CREATE_CUSTOMER = gql`
	mutation CreateCustomer($customer: CustomerInput!) {
		createCustomer(input: { customer: $customer }) {
			customer {
				id
			}
		}
	}
`;
